import { palette } from './palette';

export const homeStyle = {
  /* Login - Styles */
  '.login-root': {
    '& .hero-shaped__wrapper': {
      maxWidth: 'unset',
      minHeight: `unset !important`,

      '& .hero-shaped__left-side': {
        flex: '0 0 60%',
        maxWidth: '60%',

        '@media(min-width: 900px) and (max-width: 1200px)': {
          flex: '0 0 50%',
          maxWidth: '50%',
        },

        '& .hero-shaped__image': {
          width: '60vw',

          '@media(min-width: 900px) and (max-width: 1200px)': {
            width: '50vw',
          },
        },
      },
    },
  },
  '& .checkout_stripe_payment': {
    '& .promo-spinner': {
      backgroundColor: 'unset',
    },
  },

  '.dentalogics-container': {
    '& .savings-hero-section, .checkout-hero-section, .plan-selection-section, .faq-hero-section, .dashboard-hero-section, .find-provider-section, & .terms-hero-section, & .privacy-hero-section, & .hipaa-hero-section':
      {
        display: 'flex',
        justifyContent: 'center',
        textAlign: 'center',
        background: palette.background.main,
      },
    '@media(max-width: 900px)': {
      '& .header-wrapper': {
        paddingBottom: '10px',
      },
    },

    '& .checkout-outer-container, .plan-selection-container': {
      '& .MuiSwitch-colorSecondary.Mui-checked + .MuiSwitch-track': {
        border: `1px solid ${palette.primary.main}`,
        opacity: 1,
      },
      '& .MuiSwitch-track': {
        border: `1px solid ${palette.primary.main}`,
        background: palette.text.highlight,
      },
    },

    /* App main - styles */
    '& .app-main-content': {
      paddingTop: 0,
    },

    /* Hero Section - Styles */
    '& .home-hero-wrapper': {
      background: palette.background.main,

      '& .hero-section-alternate': {
        height: 'auto !important',
        paddingBottom: 0,

        '@media(min-width: 900px)': {
          paddingTop: 120,
        },

        '& .section-alternate__content': {
          paddingBottom: 0,

          '@media(min-width: 900px)': {
            padding: '0px',
          },

          '& .section-header': {
            '@media(min-width: 900px)': {
              minHeight: 550,
            },
          },
        },
        '& .hero-title': {
          fontSize: 42,
          fontWeight: 600,
          lineHeight: '55px',

          '@media(min-width: 600px)': {
            fontSize: 48,
            lineHeight: '60px',
          },

          '@media(min-width: 900px)': {
            fontSize: 64,
            lineHeight: '80px',
            letterSpacing: '-0.04em',
            maxWidth: 600,
          },
        },
        '& .hero-subtitle': {
          fontWeight: 400,
          fontSize: 16,
          lineHeight: '30px',
          maxWidth: 600,
          color: palette.text.primary,
          '@media(min-width: 900px)': {
            fontSize: 20,
          }
        },
        '& .MuiButton-label': {
          fontSize: 15,
          letterSpacing: '-0.03em',
        },
      },
      '& .image-wrapper': {
        paddingBottom: 0,
        marginBottom: -5,

        '& .image': {
          '@media(min-width: 900px)': {
            height: 688,
            width: 'auto',
          },
        },
      },
    },

    /* Benefits - Styles */
    '& .definition-variant-2': {
      paddingTop: '0 !important',
      paddingBottom: '0 !important',

      '@media(max-width: 900px)': {
        paddingTop: 0,
      },

      '& .benefits-wrapper': {
        '& .section-header__title': {
          paddingBottom: 64,

          '@media(max-width: 900px)': {
            paddingBottom: 24,
          },
        },
        '& .definition-service-title': {
          fontSize: 24,
          fontWeight: 600,
        },
        '& .definition-service-description': {
          fontSize: 16,
          fontWeight: 400,
          paddingBottom: 40,
          color: '#64748B',
          borderBottom: `1px solid #C9D5E0`,

          '@media(min-width: 900px)': {
            maxWidth: 350,
          },
        },
      },
    },

    /* Pricing & Benefits / Subscription - Styles */
    '& .subscription-wrapper': {
      '& .subscription-bg': {
        height: '100%',
        background: palette.primary.main,
      },
      '& .plans-loader': {
        color: palette.text.highlight,
      },
      '& #pricing-benefit-section': {
        '& .section-header__title, .section-header__subtitle': {
          color: palette.text.highlight,
          fontWeight: 'normal',
        },
        '& .section-header__title': {
          letterSpacing: '-0.04em',
        },
        '& .section-header__subtitle': {
          fontSize: 20,
          fontWeight: 400,
          letterSpacing: '-0.02em',
          maxWidth: 713,
          margin: '0 auto',
        },
        '& .planCard': {
          border: 'none',
          '&:hover': {
            border: `1px solid ${palette.primary.main}`,
            color: palette.text.primary,
            background: palette.text.highlight,
          },
          '& .highlight-divider': {
            backgroundColor: palette.text.disabled,
          },
          '& .price-value': {
            color: palette.text.primary,
          },
          '& .customGetStarted': {
            width: '96%',
            borderColor: palette.primary.main,
          },
        },
        '& .subscription-tabs-label, .summary-subtext, .summary-text': {
          color: palette.text.highlight,
        },
        '& .summary-subtext': {
          fontSize: 18,
        },
        '& .savings-summary-link': {
          textDecoration: 'underline',
          color: '#F4E187',
          cursor: 'pointer',
        },
      },
      '& .react-multi-carousel-dot button': {
        background: palette.text.highlight,
      },
      '& .MuiSwitch-colorSecondary.Mui-checked + .MuiSwitch-track': {
        background: palette.text.highlight,
        border: 'none',
        opacity: 1,
      },
      '& .MuiSwitch-thumb': {
        background: '#F4E187',
      },
      '& .MuiSwitch-track': {
        border: `1px solid ${palette.primary.main}`,
        background: palette.text.highlight,
      },
    },

    /* How it works - Styles */
    '& .howitworks-section': {
      background: palette.text.highlight,

      '& .howitworks-wrapper-left': {
        paddingRight: 80,
      },
      '& .howitworks-title': {
        marginBottom: 0,
      },
      '& .section-header__subtitle-wrapper': {
        fontSize: 18,
        fontWeight: 400,
        color: '#5A5A5A',
      },
      '& .how-cover-image': {
        height: 550,
        borderRadius: 24,
        '@media(max-width: 900px)': {
          height: '100%',
        },
      },
      '& .step-content': {
        maxWidth: 400,
        color: '#5A5A5A',
        fontSize: 16,
        fontWeight: 400,
        letterSpacing: '-0.02em',
      },
      '& .working-steps-container': {
        paddingBottom: 24,
        marginBottom: 8,
        borderBottom: '1px solid #707d9433',

        '& .step-counter': {
          borderRadius: '36px',
          backgroundColor: '#44B278',
          color: palette.text.highlight,
        },
        '& .step-title': {
          fontSize: 24,
          fontWeight: 500,
          letterSpacing: '-0.01em',
        },
      },
    },

    /* Testimonial - Styles */
    '& .testimonial-wrapper': {
      background: palette.background.secondaryLight,
      '& .section-header__title': {
        fontWeight: 'normal',
        letterSpacing: '-0.04em',
      },
      '& .react-multi-carousel-list': {
        overflow: 'visible',

        '&:before, &:after': {
          content: '""',
          position: 'absolute',
          top: 0,
          bottom: 0,
          width: 0,
          zIndex: 1,

          '@media(min-width: 600px)': {
            width: 350,
          },
          '@media(min-width: 900px)': {
            width: 450,
          },
          '@media(min-width: 1200px)': {
            width: 550,
          },
        },
        '&:before': {
          left: -115,
          background:
            'linear-gradient(to right, rgba(255, 255, 255, 1), rgba(255, 255, 255, 0))',
        },
        '&:after': {
          right: -130,
          background:
            'linear-gradient(to left, rgba(255, 255, 255, 1), rgba(255, 255, 255, 0))',
        },
      },
      '& .patient-label': {
        fontWeight: 500,
      },
    },

    /* Savings Summary */
    '& .savings-wrapper': {
      '& .MuiButton-label': {
        textTransform: 'uppercase',
        letterSpacing: '-0.03em',
      },
      '& .section-header': {
        '& .section-header__title': {
          color: palette.text.primary,
        },
        '& .section-header__subtitle': {
          color: palette.text.primary,
        },
      },
      '& .service-plan-table': {
        '& .savings-topheader': {
          color: `${palette.text.highlight} !important`,
        },

        '& .savings-header': {
          color: palette.text.primary,
        },

        '& .savings-subheader': {
          backgroundColor: palette.background.main,
          color: palette.text.primary,
          fontWeight: 600,
        },
      },

      '& .footer-bar': {
        backgroundColor: '#E9BDD9',

        '& .footer-bar-text': {
          color: palette.text.primary,
        },
      },
      '& .savings-contact-card': {
        padding: '0px 60px !important',
        background: palette.background.footer,
      },
    },

    /* Static hero banner */
    '& .home-static-hero-wrapper': {
      '& .hero-static-title': {
        fontWeight: 'normal',
        letterSpacing: '-0.04em',
      },
      '& .hero-static-subtitle': {
        color: palette.text.secondary,
      },
      '& .hero-static-bg': {
        backgroundColor: palette.text.highlight,
      },
    },

    /* Create Subscriber - Checkout flow container */
    '& .checkout-flow-container': {
      '& .provider-details': {
        border: `1px solid ${palette.text.border}`,
      },
      '& .MuiSwitch-colorPrimary.Mui-checked + .MuiSwitch-track': {
        background: palette.background.light,
        border: `1px solid ${palette.primary.main}`,
        opacity: 1,
      },
      '& .MuiSwitch-track': {
        border: `1px solid ${palette.primary.main}`,
        background: palette.text.highlight,
      },
    },

    /* FAQ */
    '& .faq-hero-section': {
      '& .hero-header-title, & .hero-header-subtitle': {
        textAlign: 'center',
      },
      '& .MuiButton-label': {
        textTransform: 'uppercase',
        letterSpacing: '-0.03em',
      },
    },
    '& .faqInnerContainer': {
      '& .accordion__collapsable-text': {
        color: palette.text.secondary,
      },
    },
    '& .faq-contact-section': {
      '& .contact-card-subtitle': {
        color: palette.text.secondary,
        fontSize: 20,
      },
    },

    /* Create Subscriber - Checkout */
    '& .checkout-outer-container': {
      '& .payment-title-root': {
        marginTop: 0,
      },
    },

    /* Contact Card - FAQ, Success Page */
    '& .faq-contact-wrapper': {
      background: palette.background.footer,
      '& .contact-img-wrapper': {
        width: '64px',
        maxWidth: '64px',
        padding: 0,
        marginRight: 8,
      },
      '& .provider-contact-details': {
        fontSize: 18,
        fontWeight: 400,
      },
      '& .provider-contact-link': {
        fontSize: 24,
        fontWeight: 500,
      },
    },

    /* Subscription Success Page */
    '& .mail-link': {
      color: palette.text.primary,
    },

    /* Dashboard Page - Appointment Header */
    '& .MuiTableRow-root .MuiTableCell-head': {
      color: palette.text.highlight,
    },

    /* Footer style */
    '& .footer-wrapper': {
      background: palette.text.highlight,
      borderTop: `1px solid ${palette.divider}`,
    },
  },
};
